import Vue from 'vue';
import Vuex from 'vuex';
import orderBy from "lodash/orderBy";
import tenantSystemApi from "@/api/tenantsystem";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isLoggedIn: false,
        mainMenuOpen: false,
        loadingOverlay: false,
        bottomNavigation: false,
        selectedPersonnelSurvey: null,
        selectedManagementSurvey: null,
        latestMessagesRead: null,
        reportFilters: {
            managementSurveyShares: [],
            personnelSurveyShares: [],
            selectedManagementSurveyShares: [],
            selectedPersonnelSurveyShares: [],
        },
        userInfo: {},
        notificationObject: {
            color: 'alert',
            message: '',
            timeOut: 4000,
            showButton: false,
            buttonText: '',
            callback: () => {
            },
        },
        tasks: [],
        menuCount: {
            ongoingSurveys: null,
            undoneTasks: null,
        },
    },
    mutations: {
        setLatestMessagesRead(state) {
            state.latestMessagesRead = localStorage.getItem('latestMessagesRead');
        },
        setLoggedIn(state, payload) {
            state.isLoggedIn = payload;
        },
        toggleMainMenuState(state) {
            state.mainMenuOpen = !state.mainMenuOpen;
        },
        setPreviousRouteName(state, val) {
            state.previousRouteName = val;
        },
        setLoadingOverlay(state, payload) {
            state.loadingOverlay = payload;
        },
        setUserInfo(state, payload) {
            state.userInfo = payload;
        },
        setSelectedPersonnelSurvey(state, payload) {
            state.selectedPersonnelSurvey = payload;
        },
        setSelectedManagementSurvey(state, payload) {
            state.selectedManagementSurvey = payload;
        },
        editReportFilters(state, payload) {
            state.reportFilters = {...state.reportFilters, ...payload};
        },
        setTasks(state, payload) {
            let tasks = [...(payload || [])];
            tasks.forEach(t => t.priorityOrderNumber = t.priority === 'HIGH' ? 0 : t.priority === 'MEDIUM' ? 1 : 2);
            tasks = orderBy(tasks, ['status', 'priorityOrderNumber'], ['desc', 'asc']);
            state.tasks = tasks;
        },
        setMenuCount(state, payload) {
            state.menuCount = payload;
        }
    },
    actions: {
        showNotification(context, payload) {
            context.state.notificationObject = {
                color: payload.color,
                message: payload.message,
                timeOut: payload.timeOut !== undefined ? payload.timeOut : 4000,
                showButton: payload.showButton !== undefined ? payload.showButton : false,
                buttonText: payload.buttonText !== undefined ? payload.buttonText : '',
                callback: payload.showButton && payload.callback ? payload.callback : () => {
                },
            };
        },
        async reloadMenuCount(context) {
            context.commit('setMenuCount', await tenantSystemApi.getMenuCount());
        },
        setTasks(context, payload) {
            context.commit('setTasks', payload);
        }
    },
});
